import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { HttpHandler } from '../http/http-handler';
import { AppConfiguration } from '../settings/app-config';
import { AppConfigService } from '../settings/app-config.service';
import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';
import { RFWebPermissaoEnum } from './permissao/cadastro-menu-routes-permission.config';
import { AuthDataService, UserAuthenticationModel } from './auth-data.service';

@Injectable()
export class AuthService {

  private config: AppConfiguration = this.appSettings.getConfiguration();
  private permissoesUsuario: RFWebPermissaoEnum[] = [];

  constructor(public router: Router,
    private http: HttpHandler,
    private appSettings: AppConfigService,
    private authDataService: AuthDataService
  ) {
  }

  signupUser(user: string, password: string) {
    //your code for signing up the new user
  }

  signinUser(user: string, password: string): Observable<boolean> {
    this.authDataService.removerDadosUsuario();
    this.authDataService.removerDadosRota();
    this.permissoesUsuario = []

    const body = `grant_type=password&username=${user}&password=${password}&client_id=${this.config.appName}`;
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

    return this.http.postCustomHeader(
      this.config.apiServiceBaseUri + 'token',
      body,
      headers
    ).pipe(
      switchMap(login =>
        this.http.get(this.config.apiServiceBaseUri + 'v1/ca/usuario/validar-status/' + user).pipe(
          map(usuarioValid => {
            if (usuarioValid.status < 4) {
              this.logout();
              throw new Error('O e-mail não foi confirmado.');
            } else {
              var authentication = new UserAuthenticationModel();
              authentication.isAuth = true;
              authentication.userName = user;
              authentication.cdRole = usuarioValid.cdRole;
              authentication.token = login.access_token;
              authentication.refreshToken =  login.refresh_token;
              authentication.email = user;
              this.authDataService.adicionarDadosUsuario(authentication);

              return true;
            }
          }),
          catchError(err => {
            throw err;
          })
        )
      )
    );
  }

  // obterRotasAutenticadas(rotas: RouteInfo[], cd_incremental = 0): Observable<any> {
  //   // console.log('obter rotas :' + `${this.config.apiServiceBaseUri}v1/if/menu/${this.authentication.cdRole}/${cd_incremental}`)
  //   return this.http.get(`${this.config.apiServiceBaseUri}v1/if/menu/${this.authDataService.usuario.cdRole}/${cd_incremental}`).pipe(
  //     map(rotasAuth => {
  //       // console.log(rotasAuth)
  //       if (rotasAuth) {
  //         rotasAuth.resultSet1.forEach(e => {
  //           if (this.permissoesUsuario.find(p => p == e.cd_incremental) == null) {
  //             this.permissoesUsuario.push(e.cd_incremental);
  //           }
  //         });
  //       }
  //       return this.filtrarRotasPorPermissoes(rotas);
  //     })
  //   );
  // }

  obterRotasAutenticadas(rotas: RouteInfo[], listaEnum: Array<number> = []): RouteInfo[] {
    if (this.permissoesUsuario.length != listaEnum.length) {
      this.permissoesUsuario.push(...listaEnum);
    }
    return this.filtrarRotasPorPermissoes(rotas);
  }

  obterTodasRotasAutenticadasUsuario(rotas: RouteInfo[], cd_incremental = 0) {
    return this.http.get(`${this.config.apiServiceBaseUri}v1/if/menu/${this.authDataService.usuario.cdRole}/${cd_incremental}`).pipe(
      switchMap(rotasAuth => {
        if (rotasAuth) {
          rotasAuth.resultSet1.forEach(e => {
            if (!this.permissoesUsuario.includes(e.cd_incremental)) {
              this.permissoesUsuario.push(e.cd_incremental);
            }
          });

          // Mapeia as chamadas recursivas
          const chamadasSubRotas = rotas.map(rota => {
            if (rota.authGuardKey && rota.willHaveSub && rota.submenu && rota.submenu.length > 0) {
              return this.obterTodasRotasAutenticadasUsuario(rota.submenu, rota.authGuardKey);
            } else if (rota.submenu && rota.submenu.length > 0) {
              return forkJoin(rota.submenu.map(subRota => {
                if (subRota.authGuardKey && subRota.willHaveSub && subRota.submenu && subRota.submenu.length > 0) {
                  return this.obterTodasRotasAutenticadasUsuario(subRota.submenu, subRota.authGuardKey);
                } else {
                  return of(null);
                }
              }));
            } else {
              return of(null);
            }
          });

          // Usa forkJoin para aguardar todas as chamadas recursivas
          return forkJoin(chamadasSubRotas).pipe(
            map(() => this.permissoesUsuario) // Retorna as permissões acumuladas
          );
        } else {
          return of(this.permissoesUsuario); // Retorna as permissões acumuladas se não houver mais chamadas
        }
      })
    );
  }

  filtrarRotasPorPermissoes(rotas: RouteInfo[]): RouteInfo[] {
    return rotas.map(rota => {
      if (rota.submenu && rota.submenu.length > 0) {
        rota.submenu = this.filtrarRotasPorPermissoes(rota.submenu);
      }
      if (rota.authGuardKey) {
        return this.permissoesUsuario.includes(rota.authGuardKey) ? rota : null;
      }
      return rota;
    }).filter(rota => rota !== null) as RouteInfo[];
  }

  possuiPermissao(item: any) {
    return true;
  }

  resetUser(usuario) {
    return this.http.put(this.config.apiServiceBaseUri + 'v1/ca/usuario/reset-senha/', usuario);
  }

  logout() {
    this.permissoesUsuario = []
    this.authDataService.removerDadosUsuario();
    this.authDataService.removerDadosRota();
    this.router.navigate(['/pages/login']);
  }
}
